// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"275":"1714243c","390":"84b08416"}[chunkId] + ".chunk.js";
};